import moment from 'moment'
import ft from './featureToggle'

export default {
  loadFlightInfo (VueApp, rsvp, callback) {
    if (rsvp.airlineCode === null) {
      return
    }
    let self = this
    VueApp.$store.commit('flightInformation/show')

    let date = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + ft.timeFormat(VueApp, true))
    let airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'))
    let airlineTime = encodeURIComponent(date.format('HH:mm:ss'))
    let flightNumber = rsvp.flightNumber || rsvp.dropoffFlightNumber
    let isDeparture = '&departure=0'
    if ((rsvp.airline === null || rsvp.airline === '') &&
      (rsvp.dropoffAirline !== null && rsvp.dropoffAirline !== '')
    ) {
      isDeparture = '&departure=1'
    }
    let url = '/availability/flights/' +
                rsvp.airlineCode + flightNumber +
                '?date=' + airlineDate +
                '&time=' + airlineTime +
                '&airport=' + rsvp.airportCode +
                isDeparture
    VueApp.$sdk.get(url, {}, r => {
      VueApp.$store.commit('flightInformation/setLoading', false)
      if (r.error) {
        VueApp.$store.commit('flightInformation/setFlightInfo', {
          airline: {
            name: rsvp.airline,
            code: rsvp.airlineCode
          },
          flightNumber: flightNumber,
          departure: {
            airportCode: '',
            airportName: '',
            time: ''
          },
          arrival: {
            airportCode: '',
            airportName: '',
            time: ''
          },
          status: 'N/A'
        })
        callback(r)
        return
      }

      let isAirportDropoff = !rsvp.airline && rsvp.dropoffAirline
      let date = isAirportDropoff ? r.departure.time.unix : r.arrival.time.unix
      let arriveDate = moment(date, 'X', r.departure.time.timezone)
      VueApp.$store.commit('flightInformation/setFlightInfo', {
        airline: r.airline,
        flightNumber: r.flight.number || rsvp.flightNumber,
        departure: {
          airportCode: r.departure.airportCode,
          airportName: r.departure.airportName,
          time: moment(r.departure.time.unix, 'X', r.departure.time.timezone).format(ft.timeFormat(VueApp, false))
        },
        arrival: {
          airportCode: r.arrival.airportCode,
          airportName: r.arrival.airportName,
          time: arriveDate.format(ft.timeFormat(VueApp, false))
        },
        status: self.translateFlightStatus(r.status, isAirportDropoff),
        type: isAirportDropoff ? 'departure' : 'arrive'
      })
      callback(r)
    })
  },

  translateFlightStatus (status, isAirportDropoff) {
    if (!isAirportDropoff) {
      switch (status) {
        case 'Scheduled': return 'Flight is arriving as scheduled.'
        case 'Proposed': return 'Flight is arriving as scheduled.'
        case 'OutGate': return 'Flight is arriving as scheduled.'
        case 'InAir': return 'Flight is currently on-air.'
        case 'Landed': return 'Flight has already arrived.'
        case 'InGate': return 'Flight has already arrived.'
        case 'Expected': return 'Flight is arriving as scheduled.'
        case 'NoTakeOffInfo': return 'Flight is arriving as scheduled.'
        case 'Delayed': return 'Flight is currently delayed.'
        case 'Cancelled': return 'Flight was cancelled.'
        case 'Unknown': return 'Flight is arriving as scheduled.'
        case 'PastFlight': return 'Flight has already arrived.'
        case 'Original' : return 'Flight is arriving as scheduled.'
      }
      return 'Flight is arriving as scheduled.'
    }

    switch (status) {
      case 'Scheduled': return 'Flight is still scheduled.'
      case 'Proposed': return 'Flight is still scheduled.'
      case 'OutGate': return 'Flight is still scheduled.'
      case 'InAir': return 'Flight is currently on-air.'
      case 'Landed': return 'Flight has already landed.'
      case 'InGate': return 'Flight has already arrived.'
      case 'Expected': return 'Flight is still scheduled.'
      case 'NoTakeOffInfo': return 'Flight is still scheduled.'
      case 'Delayed': return 'Flight is currently delayed.'
      case 'Cancelled': return 'Flight has been cancelled.'
      case 'Unknown': return 'Flight is still scheduled.'
      case 'PastFlight': return 'Flight has already been completed.'
      case 'Original' : return 'Flight is still scheduled.'
    }
    return 'Flight is still scheduled.'
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/flight-info.js